import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { Logger } from '../LoggerService/logger.service';
import { GenericService } from '../../common/common.service';

import { environment } from '../../environments/environment';
import { UtilityService } from '../utility.service';

const noop = (): any => undefined;

@Injectable()
export class ConsoleLoggerService implements Logger {
  
  private __IsEnableServerLoggingForClientError: string = 'False';
  private documentURL: string;
  private baseApiURL: string;
  private urlAarray: string[];
  private baseURL: string;
  public getApiUrl: string = this.__oUtilityService.GetBasewebAPIURL();
  private hostname: string;

  constructor(@Inject(DOCUMENT) private document: any, public __oUtilityService: UtilityService, public _postDataService: GenericService)
  {     
    this.__IsEnableServerLoggingForClientError = sessionStorage.getItem("EnableServerLoggingForClientError");
  }

  get info() {
    return console.info.bind(console);
  }

  get warn() {
    return console.warn.bind(console);
  }

  get error() {
    return console.error.bind(console);
  }

  invokeConsoleMethod(type: string, args?: any): void {
    const logFn: Function = (console)[type] || console.log || noop;
    logFn.apply(console, [args]);
  }

  Write(e: any, Type: string, StackTrace: string) {    

    switch (Type)
    {
      case 'Error':
        switch (e.constructor)
        {
          case Error:            
            console.error(e.message + "\n" + StackTrace);
            this.LogErrorIntoDB(e.message + "\n" + StackTrace);
          default:
            console.error(StackTrace);
            this.LogErrorIntoDB(StackTrace);           
        }
        
      case 'Info':
        console.warn(StackTrace);
      case 'Warn':
        console.info(StackTrace);
      default:        
        console.error(StackTrace); 
    }


  }

  private LogErrorIntoDB(ErrorMessage:string) {
    if (this.__IsEnableServerLoggingForClientError == "TRUE") {
      let oException: any = {};
      oException.Message = ErrorMessage;
      this._postDataService.UpdateAllDataByPromise(oException, this.getApiUrl + "api/PortalMenu/PutClientError").then(
        result => this.OnSuccessSave(result)
      ).
        catch(error => this.OnError(error))

    }
  }

  private OnError(error: any) {
    console.error(error);
  }
  private OnSuccessSave(response: any) { }



}
